//金格对接
import {
  isPlainObject,
  isDef,
  toString
} from 'utils'
const defaultOptions = {
  handleVerify: true, //是否开启手动验证
  keysn: 'xbry1' //测试时的用户名
}
const functionOptions = ['okCallHook', 'showCallHook', 'deleteAsyncOpt', 'deleteHook']
export default class KingGridElecseal {
  // keysn = '' //金格系统用户名 初始化时要用到 必填 String
  // documentid = '' // 金格要保护的文档id 初始化时要用到 必填 String
  // serverUrl = '' //金格服务器地址 初始化时要用到 必填 String
  // handleVerify = true // 是否开启手动验证 Boolean
  // getVerifyData = () => {} //实时获取文档数据和待验证的文档数据
  // protectedItems = [] //初始化时保护的数据项
  // okCallHook = () => {} //确定盖章后的回调
  // showCallHook = () => {} //执行盖章操作的回调
  // deleteAsyncOpt = () => {} //删除签章后删除业务库签章
  // deleteHook = () =>  {} //删除签章后的业务操作
  constructor(options) {
    if (!Signature) {
      console.error('未加载金格sdk')
      return
    }
    if (!options || !isPlainObject(options)) {
      console.error('配置错误')
      return
    }
    this.options = Object.assign({}, defaultOptions, options)
    const {
      keysn,
      documentid,
      serverUrl,
      handleVerify,
      getVerifyData,
      protectedItems,
      okCallHook,
      showCallHook,
      deleteAsyncOpt,
      deleteHook,
      readonly
    } = this.options
    if (typeof keysn === 'string') {
      this.keysn = this.options.keysn
    }
    if (typeof documentid === 'string') {
      this.documentid = this.options.documentid
    }
    if (typeof serverUrl === 'string') {
      this.serverUrl = serverUrl
    }
    this.handleVerify = !!handleVerify
    if (typeof getVerifyData === 'function') {
      this.getVerifyData = getVerifyData
    }
    //收集初始要保护的数据key
    if (isPlainObject(protectedItems)) {
      this.protectedItems = protectedItems
    }
    functionOptions.forEach(key => {
      if (this.options && this.options[key] && typeof(this.options[key]) === 'function') {
        this[key] = this.options[key]
      }
    })
    this.init()
  }
  init() {
    this.initCount = 0
    this.setVerifyData()
    this.initKingGrid()
  }
  initKingGrid() {
    Signature.init({ //初始化属性
      keysn: this.keysn,
      delCallBack: this.delCB.bind(this),
      imgtag: 0, //签章类型：0：无; 1:公章; 2:私章; 3:法人章; 4:法人签名; 5:手写签名
      moveable: false,
      timestamp: false, //获取签章服务器时间
      valid: false, //签章和证书有效期判断， 缺省不做判断
      icon_move: false, //移动签章按钮隐藏显示，缺省显示
      icon_remove: true, //撤销签章按钮隐藏显示，缺省显示
      icon_sign: false, //数字签名按钮隐藏显示，缺省显示
      icon_signverify: false, //签名验证按钮隐藏显示，缺省显示
      icon_sealinfo: !!this.handleVerify , //签章验证按钮隐藏显示，缺省显
      icon_move_donot: false,
      certType: 'server', //设置证书在签章服务器
      sealType: 'server', //设置印章从签章服务器取
      serverUrl: this.serverUrl, //
      documentid: this.documentid, //设置文档ID
      documentname: `测试文档${this.documentid}`, //设置文档名称
      pw_timeout: 's1800', //s：秒；h:小时；d:天
      scaleImage: 1, //签章图片的缩放比例
      showProtectedBtn: false, //设置是否显示保护项按钮
      showSealsDlg: true, //是否显示签章选择界面 false：不弹窗 'auto':自动，如果符合条件的只有一个印章则不弹签章选择框。如果有多个就弹签章选择框
      showNoPW: false, //设置选择签章对话框去掉密码输入显示
      verification: false, //开启短信验证码方式去加盖签名
      handleVerify: !!this.handleVerify
    })
  }
  //设置自定义待验证数据
  setVerifyData() {
    const that = this
    Signature.verifyData = function(data) {
      let verifyData = that.getVerifyData && that.getVerifyData()
      if (verifyData) {
        verifyData = that.normalizeProtectedItems(verifyData)
        console.log('待验证的数据', verifyData)
        Object.keys(data).forEach(key => {
          const obj = data[key]
          let val = verifyData[obj['field']]
          obj['value'] = val
        })
      }
      return data
    }
  }
  customProtectedItems(protectedItems) {
    const result = []
    if (!protectedItems) return result
    const keys = Object.keys(protectedItems)
    if (!keys.length) return result
    keys.map((key, index) => {
      if (!/^___/.test(key) && !/_DISPLAY$/.test(key)) {
        const obj = {}
        obj['field'] = key
        if (isDef(protectedItems[key]) && typeof(protectedItems[key]) !== 'string') {
          protectedItems[key] = String(protectedItems[key])
        }
        obj['value'] = protectedItems[key]
        obj['desc'] = `保护项--${key}`
        result.push(obj)
      }
    })
    return result
  }
  normalizeProtectedItems(protectedItems) {
    if (protectedItems && isPlainObject(protectedItems)) {
      const newProtectedItems = JSON.parse(JSON.stringify(protectedItems))
      const obj = {}
      if (this.protectedItems) {
        Object.keys(this.protectedItems).forEach((key, index) => {
          let val = newProtectedItems[key]
          if (!isDef(val)) {
            val = ''
          }
          obj[key] = toString(val)
        })
      } else {
        Object.keys(newProtectedItems).forEach((key, index) => {
          let val = newProtectedItems[key]
          if (!isDef(val)) {
            val = ''
          }
          obj[key] = toString(val)
        })
      }
      return obj
    } else {
      return {}
    }
  }
  //执行盖章操作
  runSignatureCreator(pos) {
    const that = this
    const signatureCreator = Signature.create()
    const verifyData = this.getVerifyData && this.getVerifyData()
    let protectedItems = this.normalizeProtectedItems(verifyData)
    protectedItems = this.customProtectedItems(protectedItems)
    console.log('=========保护项为==========', protectedItems)
    signatureCreator.run({
      protectedItems: protectedItems, //设置定位页面DOM的id，自动查找ID，自动获取保护DOM的kg-desc属性作为保护项描述，value属性为保护数据。不设置，表示不保护数据，签章永远有效。
      position: pos,
      autoCert: false,
      okCall: function(fn, image) { //点击确定后的回调方法，this为签章对象 ,签章数据撤销时，将回调此方法，需要实现签章数据持久化（保存数据到后台数据库）,保存成功后必须回调fn(true/false)渲染签章到页面上
        that.okCallHook && that.okCallHook.call(this, fn, image, pos)
      },
      cancelCall: function() { //点击取消后的回调方法
        console.log("取消！")
      },
      moveable: false,
      showCall: function(content, dialog, onOk, u) {
        that.showCallHook && that.showCallHook.call(this, content, dialog, onOk, u)
      }
    })
  }
  saveKingGridSignnature(id, data) {
    const signatureCreator = Signature.create()
    signatureCreator.saveSignature(this.documentid, id, data)
  }
  getSaveSignatures() {
    return new Promise((resolve, reject) => {
      const signatureCreator = Signature.create()
      signatureCreator.getSaveSignatures(this.documentid, (signs) => {
        resolve(signs)
      })
    })
  }
  initHandleVerify(signdata, posArray, initHandleVerifyHook) {
    Signature.resetSignaturePos(posArray)
    Signature.loadSignatures(signdata, () => {
      //初始化手动验证
      const invalidSignatureArray = Signature.verify()
      initHandleVerifyHook && initHandleVerifyHook(invalidSignatureArray)
    }, null, Signature.initCount > 0)
    Signature.initCount++
  }
  verify() {
    Signature.verify()
  }
  //获取签章位置 
  getSealPos(signatureData) {
    if (signatureData.position && isPlainObject(signatureData.position)) {
      const pos = signatureData.position
      const keys = Object.keys(pos)
      if (keys.length) {
        return keys[0]
      } else {
        console.error('无法获取对应签章位置')
      }
    } else {
      console.error('无法获取对应签章位置')
    }
  }
  //签章删除后清除页面显示
  delCB(signatureid, signatureData) {
    const pos = this.getSealPos(signatureData)
    let vm
    if (typeof(Signature.kingGridVmMap) !== 'undefined') {
      vm = Signature.kingGridVmMap[signatureid]
      console.log('组件模式',  vm.schema)
    }
    for (var key in Signature.list) {
      if (signatureid == key && Signature.list[signatureid].keysn == signatureData.keysn) {
        //暂时不能删除
        if (vm && vm.schema === 'default') {
          const signatureCreator = Signature.create()
          signatureCreator.removeSignature(signatureData.documentid, signatureid)
          vm.deleteAsyncOpt && vm.deleteAsyncOpt(signatureid, pos)
        }
        break;
      }
    }
    vm.deleteHook && vm.deleteHook(signatureid, pos)
    return true;
  }
  getSealPos(signatureData) {
    if (signatureData.position && isPlainObject(signatureData.position)) {
      const pos = signatureData.position
      const keys = Object.keys(pos)
      if (keys.length) {
        return keys[0]
      } else {
        console.error('无法获取对应签章位置')
      }
    } else {
      console.error('无法获取对应签章位置')
    }
  }
  //重新渲染单个签章
  resetPos({sid, id, sdata}) {
    const posArray = []
    console.log('pos', id)
    const mapPos = {}
    mapPos.signatureid = sid
    mapPos.extra = {
      position: id
    }
    posArray.push(mapPos)
    Signature.resetSignaturePos(posArray)
    const signDataArr = []
    const obj = {}
    obj['signatureid'] = sid
    obj['signatureData'] = sdata
    signDataArr.push(obj)
    Signature.loadSignature(obj['signatureid'], obj['signatureData'], null, null, true)
  }
  removeDom(posId) {
    const dom = document.querySelector(`.kg-img-div-${posId}`)
    if (dom) {
      dom.parentNode.removeChild(dom)
    }
  }
}
